/* eslint-disable max-len */
import METADATA from 'src/constants/metadata';

const HomeJsonLd = () => {
	const jsonHome = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Hallobumil',
		url: METADATA.WEB_URL,
		logo: METADATA.WEB_URL+'/hallobumil-logo.png',
		sameAs: [
			'https://www.facebook.com/hallobumil',
			'https://www.instagram.com/hallobumil_id',
			'https://www.tiktok.com/@hallobumil_id',
			'https://www.youtube.com/c/hallobumil',
		],
		contactPoint: {
			'@type': 'ContactPoint',
			telephone: '+6285134954019',
			contactType: 'Customer Service HalloBumil',
		},
	};

	const jsonHomeAdress = {
		'@context': 'https://schema.org',
		'@type': 'LocalBusiness',
		name: 'hallobumil Office',
		image: METADATA.WEB_URL+'/hallobumil-office.png',
		address: {
			'@type': 'PostalAddress',
			streetAddress: 'Jl. Jenderal Ahmad Yani NO.2, RT. 003 RW. 013',
			addressLocality: 'Kayu Putih, Kec. Pulo Gadung, Kota Jakarta Timur',
			postalCode: '13210',
			addressCountry: 'ID',
		},
		telephone: '+6285134954019',
	};

	const jsonHomeFAQ = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: [
			{
				'@type': 'Question',
				name: 'Apakah saya dapat mengubah alamat email atau alamat kontak saya?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Saat ini Mama bisa mengganti email dan alamat kontak yang sudah didaftarkan ya :)',
				},
			},
			{
				'@type': 'Question',
				name: 'Jika saya menghapus akun saya, apakah data saya masih dapat ditarik kembali?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Jika Mama dengan sengaja ataupun tidak sengaja menghapus data (memulai ulang siklus atau pindah fase dari kehamilan ke pasca kehamilan), jangan khawatir Ma, data Mama tidak hilang kok. Data Mama masih tersimpan dan aman, memang Mama sudah tidak bisa mengakses data Mama di siklus yang lama, tetapi jangan khawatir, saat ini kami sedang mengembangkan fitur yang memungkinkan Mama untuk melihat data dan informasi Mama di siklus yang lama.',
				},
			},
			{
				'@type': 'Question',
				name: 'Saya hendak memakai aplikasi Hallobumil, tetapi loadingnya tidak berhenti juga. Apa yang harus saya lakukan?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama tidak perlu khawatir jika Mama mengalami hal ini. Data Mama tidak hilang kok dan masih tersimpan dan aman. Mungkin akan sedikit merepotkan Mama, mohon lakukan hal berikut: - uninstall terlebih dulu, - install sekali lagi menggunakan versi terbaru yang ada di playstore, - lalu mohon login menggunakan akun Mama. Jika data Mama masih belum muncul, mohon sampaikan keluhan yang Mama alami di halaman hubungi kami. Mohon tuliskan keluhan Mama dengan lengkap dan jelas di kolom yang sudah disediakan dan mohon meng-upload juga data-data yang mendukung laporan Mama (bila ada). Kami akan menghubungi dan membantu Mama dalam beberapa saat. ',
				},
			},
			{
				'@type': 'Question',
				name: 'Apa saja yang ada di dalam Aplikasi Hallobumil?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Aplikasi Hallobumil merupakan aplikasi kehamilan dan parenting interaktif pertama di Indonesia yang mendampingi Mama melewati masa persiapan kehamilan, kehamilan, dan tumbuh kembang anak. Sebagai aplikasi kehamilan bahasa Indonesia, terdapat beberapa fitur yang dapat membantu Mama dan Papa untuk mempermudah perjalanan Mama dan Papa melewati berbagai fase mulai dari persiapan hingga tumbuh kembang anak. Setelah proses download aplikasi Hallobumil selesai, Mama dapat menggunakan berbagai fitur di dalam aplikasi Hallobumil sesuai dengan kebutuhan dan fase yang sedang Mama alami.',
				},
			},
			{
				'@type': 'Question',
				name: 'Jika terjadi eror apa yang dapat saya lakukan?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama tidak perlu khawatir apabila terjadi eror di aplikasi Mama karena data dan informasi Mama tetap aman. Mama bisa menyampaikan eror yang terjadi di halaman hubungi kami. Mohon tuliskan keluhan Mama dengan lengkap dan jelas di kolom yang sudah disediakan. Mohon untuk meng-upload juga data-data yang mendukung laporan Mama. Kami akan menghubungi dan membantu Mama dalam beberapa saat.',
				},
			},
			{
				'@type': 'Question',
				name: 'Apa yang harus saya lakukan jika saya lupa password?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama tidak perlu khawatir apabila Mama lupa password. Mama dapat menekan tombol lupa password. Pada fitur lupa password, Mama cukup menekan tombol lupa kata sandi dan kami akan mengirimkan password Mama ke email yang Mama gunakan. Apabila Mama mengalami masalah, Mama dapat menggunakan fitur hubungi kami. Mohon tuliskan keluhan Mama dengan lengkap dan jelas di kolom yang sudah disediakan. Mohon untuk meng-upload data-data yang mendukung laporan Mama. Kami akan menghubungi dan membantu Mama dalam beberapa saat.',
				},
			},
			{
				'@type': 'Question',
				name: 'Apakah saya dapat menggunakan Aplikasi Hallobumil untuk kehamilan kedua saya?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama dapat menggunakan Hallobumil untuk kehamilan ke-2. Jangan khawatir, data Mama di kehamilan pertama memang tidak dapat diakses lagi, tetapi data tersebut tidak hilang kok. Data kehamilan Mama yang sebelumnya masih tersimpan dan aman, meskipun memang Mama sudah tidak bisa mengakses data tersebut, tetapi saat ini kami sedang mengembangkan fitur yang memungkinkan Mama untuk melihat data dan informasi Mama di siklus sebelumnya.',
				},
			},
			{
				'@type': 'Question',
				name: 'Saya mencoba login berulang kali, tetapi selalu gagal, apa yang harus saya lakukan?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama tidak perlu khawatir apabila hal ini terjadi. Mama bisa menyampaikan keluhan yang Mama alami di halaman hubungi kami. Mohon tuliskan keluhan Mama dengan lengkap dan jelas di kolom yang sudah disediakan dan mohon meng-upload juga data-data yang mendukung laporan Mama (bila ada). Kami akan menghubungi dan membantu Mama dalam beberapa saat.',
				},
			},
			{
				'@type': 'Question',
				name: 'Saya ter-logout otomatis, dan ketika saya mencoba masuk/login kembali, data-data saya hilang, apa yang harus saya lakukan?',
				acceptedAnswer: {
					'@type': 'Answer',
					text: 'Mama tidak perlu khawatir jika Mama mengalami hal ini. Data Mama tidak hilang kok dan masih tersimpan dan aman. Kemungkinan besar, Mama salah menginput email yang Mama gunakan di Hallobumil. Untuk mengetahui email yang dulu Mama daftarkan di Hallobumil, mama bisa bertanya menggunakan fitur hubungi kami. Mohon tuliskan keluhan Mama dengan lengkap dan jelas di kolom yang sudah disediakan dan mohon meng-upload juga data-data yang mendukung laporan Mama (bila ada). Kami akan menghubungi dan membantu Mama dalam beberapa saat. ',
				},
			},
		],
	};

	return (
		<>
			<script
				defer
				id="Home"
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonHome) }}
			/>
			<script
				defer
				id="HomeAdress"
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonHomeAdress) }}
			/>
			<script
				defer
				id="HomeFAQ"
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonHomeFAQ) }}
			/>
		</>
	);
};

export default HomeJsonLd;
